import React from 'react';
import PropTypes from 'prop-types';
import styles from './TermAndConditionsContent.module.scss';

export const TermAndConditionsContent = React.forwardRef((props, ref) => {

  return (
    <div className={styles.container}>
      <h4>Bienvenido a IdAuto Reporte</h4>
      <p>
        IdAuto Reporte es un servicio para obtener en minutos un reporte completo sobre vehículos usados. Fue
        desarrollado por Dox Servicios SpA, Sociedad por Acciones Constituida en Chile, RUT. Nº 77.081.522-3,
        representada por don Enrique Lazo Ureta, cédula nacional de Identidad Nº 8.321.864-9, ambos domiciliados en
        Fanor Velasco 85, Piso 3, comuna y ciudad de Santiago.
      </p>

      <p>
        Los cambios de los Términos y Condiciones serán actualizados en el Sitio Web al menos 7 días antes de la fecha
        en que surta efecto la modificación. Podrá verificar si el aviso ha sido modificado, consultando la fecha de
        “actualización” que aparece al inicio este documento. Recomendamos mantener vigente la dirección de correo
        electrónico que haya proporcionado y que nos notifique de manera oportuna sobre cualquier cambio en su correo
        electrónico, con el fin de que pueda recibir las notificaciones con respecto a las modificaciones sustanciales a
        estos Términos. Si no está de acuerdo con los nuevos Términos, podrá dejar de utilizar el Sitio Web. De otra
        forma, los nuevos Términos surtirán efectos después de comunicados. Cada vez que contrate en el Sitio Web y/o a
        través de cualquier aplicación móvil que ofrezcamos, deberá aceptar la versión vigente de estos Términos y
        Condiciones para proceder con la contratación del servicio. Los Términos vigentes al momento de cualquier
        contrato son los que aplicarán al mismo.
      </p>

      <p>
        Si tiene alguna pregunta con respecto a estos, por favor contáctenos al correo electrónico <a
        href="mailto:soporte-idauto@dox.cl">soporte-idauto@dox.cl</a>.
      </p>

      <h4>GENERALIDADES</h4>
      <p>
        Estos Términos y Condiciones (Términos) regulan el acceso y uso de las Plataformas virtuales, así como los
        servicios de la página de Internet de IdAuto Reporte, <a
        href="www.reporte.idauto.cl">www.reporte.idauto.cl</a> y de cualquier información, texto,
        video u otros contenidos desarrollados por IdAuto Reporte.
      </p>
      <p>
        Estos Términos son aplicados e incorporados a cada uno de los servicios o planes que contrates con IdAuto
        Reporte.
      </p>
      <p>
        El uso de esta página de Internet, así como estos Términos, y los contratos que se hagan a través la página de
        IdAuto Reporte, están regulados por las leyes chilenas.
      </p>

      <h4>DEFINICIONES</h4>
      <p>
        Para los propósitos de este documento, los términos que a continuación se definen tendrán la siguiente
        definición:
      </p>

      <ul>
        <li>Usuario: Es la persona natural o jurídica que utiliza la plataforma de IdAuto Reporte.</li>
        <li>
          Reporte: Producto ofrecido en la plataforma de IdAuto Reporte. Los Reportes contienen la siguiente
          información de los automóviles respecto de los cuales se hace la consulta:

          <ul className={styles.letterStyle}>
            <li>Información básica del vehículo: marca, modelo, año de fabricación, número de motor y chasis, entre
              otros.
            </li>
            <li>
              Información sobre gravámenes del automóvil: se refiere a información relativa a multas cursadas, encargo
              por robo, entre otros.
            </li>
            <li>
              Información de uso del automóvil: historial de propietarios y sus giros, en caso de tratarse de una
              persona jurídica; utilización del mismo en flotas de transporte público, escolar y/o transporte privado,
              entre otros.
            </li>
            <li>
              Información mecánica del automóvil: contiene información relativa a remates por pérdidas totales, estado
              actual de revisión técnica, historial de revisiones técnicas pasadas por planta de revisión y registros de
              kilometraje.
            </li>
          </ul>
        </li>
      </ul>


      <h4>LIBERTAD DE NAVEGACIÓN Y ACEPTACIÓN DE LOS TÉRMINOS Y CONDICIONES</h4>
      <p>
        Usted es libre de navegar, visitar y consultar la página de IdAuto Reporte, sin que se generen obligaciones. A
        menos que inequívocamente, exprese su voluntad de contratar alguno de los servicios ofrecidos de acuerdo con
        estos términos y condiciones.
      </p>
      <p>
        Para aceptar estos Términos, solo tienes que hacer click donde te aparezca esta opción en la página de IdAuto
        Reporte.
      </p>


      <h4>ANTECEDENTES PREVIOS</h4>
      <p>
        IdAuto Reporte recopila información sobre vehículos usados obtenida de distintos registros, consulta y consolida
        sus datos a través de la disponibilidad de bases de datos y fuentes públicas y privadas, desarrolladas por
        terceros; en conformidad a lo dispuesto por la Ley 19.628.
      </p>
      <p>
        No se cobra un precio por la entrega de la información gratuita alojada en la web, sino por su capacidad de
        recopilar, gestionar y organizar la información en la generación del Reporte.
      </p>
      <p>
        El Reporte emitido no contiene información personal, privilegiada, confidencial o sensible, sino que contiene
        datos que buscan informar adecuadamente la situación legal de un vehículo motorizado determinado.
      </p>
      <p>
        Por otra parte, la aplicación almacena información básica de contacto del Usuario. Toda la información entregada
        es almacenada bajo las más estrictas medidas de seguridad y no se permite el acceso de terceros a sus
        servidores.
      </p>

      <h4>CONDICIONES DE USO</h4>
      <p>
        El Usuario se compromete a hacer uso de la misma con fines exclusivamente personales. La aplicación IdAuto
        Reporte tiene por fin poner a disposición la información relativa vehículos usados y ofertas o promociones de
        terceros sobre productos o servicios relacionados al rubro automovilístico.
      </p>

      <p>
        El Usuario no podrá hacer uso de la misma con fines ilícitos que lesionen derechos e intereses de IdAuto
        Reporte, terceros o que de cualquier forma puedan dañar, inutilizar, sobrecargar, deteriorar o impedir la normal
        utilización de este sitio, los equipos informáticos o los documentos, archivos y toda clase de contenidos
        almacenados en cualquier equipo informático de IdAuto Reporte.
      </p>
      <p>
        Especialmente se considera conducta contraria a los presentes términos y condiciones de la aplicación web
        <a href="www.reporte.idauto.cl"> www.reporte.idauto.cl</a> sin ser esta lista exhaustiva o taxativa, la
        extracción automática de información, copia
        de la información para usos no establecidos en el presente instrumento y la reventa a terceros de la información
        obtenida desde la aplicación.
      </p>

      <h4>PROPIEDAD INTELECTUAL</h4>
      <p>
        Todos los contenidos incluidos en este sitio, como textos, material gráfico, logotipos, íconos de botones,
        códigos fuente, videos, imágenes, audio clips, descargas digitales y compilaciones de datos, son propiedad de
        IdAuto Reporte, Asesorías DOX o de sus proveedores de contenidos, y están protegidos por las leyes chilenas e
        internacionales sobre propiedad intelectual. Los materiales gráficos, logotipos, encabezados de páginas, frases
        publicitarias, íconos de botones, textos escritos y nombres de servicios incluidos en este sitio son marcas
        comerciales, creaciones o imágenes comerciales de propiedad de IdAuto Reporte en Chile. Dichas marcas,
        creaciones e imágenes comerciales no se pueden usar en relación a ningún producto o servicio que pueda causar
        confusión entre los usuarios y en ninguna forma que desprestigie o desacredite a IdAuto Reporte. Las demás
        marcas comerciales que no sean de propiedad de IdAuto Reporte y que aparezcan en este sitio pertenecen a sus
        respectivos dueños.
      </p>
      <p>
        Todos los derechos no expresamente otorgados en estos Términos son reservados por IdAuto Reporte o sus
        concesionarios, proveedores, editores, titulares de derechos u otros proveedores de contenidos. Ningún producto,
        imagen o sonido pueden ser reproducidos, duplicados, copiados, vendidos, revendidos, visitados o explotados para
        ningún fin, en todo o en parte, sin el consentimiento escrito previo de IdAuto Reporte. No se puede enmarcar o
        utilizar técnicas de enmarcación para encerrar alguna marca comercial, logotipo u otra información registrada o
        patentada (incluyendo imágenes, texto, disposición de páginas, o formulario) de IdAuto Reporte, sin nuestro
        consentimiento escrito previo. Tampoco se puede usar meta etiquetas ni ningún otro “texto oculto” que use el
        nombre o marcas comerciales de IdAuto Reporte, sin autorización escrita previa de esta empresa. Se prohíbe hacer
        un uso indebido de este sitio o de estas marcas, licencias o patentes. Lo anterior, sin perjuicio de las
        excepciones expresamente señaladas en la ley.
      </p>
      <p>
        La información específica contenida en los Reportes constituye una compilación para efectos de la Ley de
        Propiedad Intelectual Nº17.336; de forma tal que su reproducción no autorizada o su utilización de cualquier
        modo diferente al expresamente permitido por este instrumento, constituye una infracción de los derechos de
        propiedad intelectual.
      </p>

      <h4>SERVICIOS DE IDAUTO REPORTE</h4>
      <p>
        IdAuto Reporte pone a disposición del Usuario un Reporte con información relacionada al vehículo solicitado.
        Para poder tener acceso al Reporte debe completar los campos señalados en la aplicación, aportando la
        información necesaria para identificar el vehículo.
      </p>
      <p>
        Para contratar los servicios es necesario hacer lo siguiente:
      </p>

      <ul className={styles.numberStyle}>
        <li>
          Iniciar sesión en el sitio ingresando su correo electrónico y al recibir el correo con la notificación de
          acceso presionar el botón “Ingresar”.
        </li>
        <li>
          Para solicitar el Reporte, deberá completar los campos señalados en la plataforma, llenando los campos con la
          información necesaria para identificar el vehículo.
        </li>
        <li>
          Seleccionar el medio de pago.
        </li>
        <li>
          Confirmar haber leído y aceptado estos Términos y Condiciones.
        </li>
        <li>
          Una vez que haya pagado, se le enviará al correo registrado el reporte.
        </li>
      </ul>

      <h4>PAGO DE LOS SERVICIOS</h4>
      <p>
        Los servicios de IdAuto Reporte podrán pagarse, a través de los siguientes medios de pago:
      </p>

      <ul className={styles.numberStyle}>
        <li>
          Tarjeta de crédito bancarias Visa, MasterCard, Dinners Club International o American Express. Al pagar con
          tarjetas de crédito está la opción de pagar en cuotas.
        </li>
        <li>
          Tarjetas de débito bancarias acogidas al sistema Red compra, emitidas en Chile por bancos nacionales.
        </li>
      </ul>
      <p>
        El pago con tarjetas de pago se realizará a través de Khipu o Webpay, que son un sistema de pago electrónico que
        se encarga de hacer el cargo automático a la cuenta bancaria del usuario.
      </p>

      <p>
        Hacemos presente que este módulo no pertenece a IdAuto Reporte ni a DOX, por lo que la continuidad de su
        prestación de servicios en el tiempo, así como el correcto funcionamiento de sus herramientas y botones de pago
        en línea, son responsabilidad de Khipu o Webpay y en ningún caso de IdAuto Reporte o de DOX.
      </p>

      <h4>ACCESO AL REPORTE</h4>
      <p>
        Al adquirir un Reporte, los usuarios podrán acceder a ellos y visualizarlos a través de las plataformas de
        IdAuto Reporte. Además, se le enviará un correo electrónico con el Reporte solicitado adjunto y la boleta o
        factura.
      </p>

      <p>
        Solo estará disponible en la aplicación la(s) patente(s) del último Reporte generado teniendo en cuenta su placa
        patente única solicitada.
      </p>

      <h4>POLÍTICA DE DEVOLUCIONES</h4>
      <p>
        IdAuto Reporte declara expresamente que no se realizan cambios ni devoluciones una vez finalizado el proceso de
        compra. Por esta razón, invitamos al Usuario a revisar cuidadosamente los datos de su orden antes de confirmar
        la compra.
      </p>

      <h4>FUENTES DE INFORMACIÓN DEL REPORTE</h4>
      <p>
        La información contenida en los Reportes emitidos por IdAuto Reporte ha sido recopilada directamente de
        diferentes fuentes de información que no son controladas por IdAuto Reporte. Los datos que estructuran el
        Reporte en algún momento pueden no estar actualizados ni exactos, por lo que IdAuto Reporte no se hace
        responsable de las consecuencias derivadas del uso de información errada, inexacta o desactualizada.
      </p>

      <h4>DATOS PERSONALES</h4>
      <p>
        Con la aceptación de estos Términos y Condiciones, usted garantiza que la información que ha suministrado para
        la contratación del Reporte es veraz, completa, exacta y actualizada. De acuerdo a la Ley 19.628 de Protección
        de la Vida Privada, los datos que incorpore en la página formarán parte de la base de datos de IdAuto Reporte y
        serán destinados para los fines del contrato, comunicación en general entre IdAuto Reporte y sus usuarios,
        validar datos de compra, responder sus consultas, entre otros.
      </p>
      <p>
        IdAuto Reporte jamás solicita datos personales o financieros a través de correo electrónico.
      </p>
      <p>
        IdAuto Reporte asume que los datos han sido incorporados por su titular o por persona autorizada por éste y que
        son correctos y exactos.
      </p>
      <p>
        Los especialistas vinculados a IdAuto Reporte que tengan acceso a la información entregada por el Usuario están
        sujetos a no divulgar la misma.
      </p>
      <p>
        IdAuto Reporte declara que hace su mayor esfuerzo para evitar la divulgación no autorizada bajo el presente
        instrumento de cualquier información relativa al Usuario.
      </p>
      <p>
        IdAuto Reporte garantiza a sus usuarios el libre ejercicio de sus derechos de acceso, rectificación, cancelación
        y oposición establecidos en la Ley 19.628.
      </p>

      <h4>RESPONSABILIDAD DE LOS USUARIOS RESPECTO DE LA INFORMACIÓN REGISTRADA EN EL SITIO</h4>
      <p>
        IdAuto Reporte va a tomar todas las medidas necesarias y prudentes para resguardar la seguridad de los datos
        personales, como sistema de encriptación de información, certificados de
        seguridad u otros medios que consideremos pertinentes. En caso de detectarse cambios en la información que haya
        registrado en el sitio, o ante cualquier irregularidad en las transacciones relacionadas con su identificación o
        la del medio de pago, o simplemente como medida de protección de su identidad, nuestros ejecutivos podrán
        contactarle por vía telefónica o e-mail, para corroborar sus datos e intentar evitar posibles fraudes.
      </p>
      <p>
        Los Usuarios son responsables por la información que registren en la página. Por lo anterior, cada Usuario será
        única y exclusivamente responsable ante IdAuto Reporte y otras personas por las consecuencias que puedan
        derivarse de la utilización con fines o efectos ilícitos o contrarios al presente Términos y Condiciones por
        aquellos datos que no sean verídicos o fidedignos.
      </p>

      <h4>SERVICIO AL USUARIO</h4>
      <p>
        IdAuto Reporte pone a disposición de sus Usuarios un servicio de ayuda rápida con el fin de contestar todas y
        cada una de las dudas que pueda tener sobre la aplicación web y solucionar cualquier problema con los servicios
        prestados.
      </p>
      <p>
        Los usuarios pueden hacer uso del servicio enviando un correo electrónico a la dirección: <a
        href="mailto:soporte-idauto@dox.cl">soporte-idauto@dox.cl</a>
      </p>

      <h4>LEGISLACIÓN APLICABLE Y COMPETENCIA</h4>
      <p>
        Los presentes Términos y Condiciones se rigen por las leyes de la República de Chile. Cualquier controversia o
        conflicto derivado de la utilización de las plataformas de IdAuto Reporte, sus Términos y Condiciones y las
        Políticas de Tratamiento de Datos, su validez, interpretación, alcance o cumplimiento, será sometida a las leyes
        aplicables de la República de Chile. Ya sea en forma de reclamación o litigio tendrá lugar únicamente en
        Santiago de Chile, y el usuario acepta dicha legislación, jurisdicción y lugar de los tribunales, renunciando
        con ello a cualquier objeción en cuanto a inconveniencia de foro.
      </p>
    </div>
  );
});

TermAndConditionsContent.propTypes = {
  onCloseAction: PropTypes.func
};

export default TermAndConditionsContent;
